/**
 * Spinner Listener
 *
 * Registers document and window listeners used by the spinner subsystem.
 */

import { SpinnerHandler, FormSpinners } from "./spinner-handler";
import { getEventScope } from "../../core/event-scope/event-scope";

export { FormSpinners };

class Spinnerlistener {
    public static setup(handler: SpinnerHandler): void {
        const docScope = getEventScope(document, "spinner");
        const winScope = getEventScope(window, "spinner");

        const onDomReady = (): void => {
            docScope.once("submit", () => {
                docScope.on("submit", (event) => handler.handleFormSubmit(event));
            });

            docScope.once("click", () => {
                docScope.on("click", (event) => handler.handleLinkClick(event));
            });

            handler.handleDOMReady();
        };

        if (document.readyState === "loading") {
            docScope.once("dom-ready", () => {
                docScope.on("DOMContentLoaded", onDomReady, { once: true });
            });
        } else {
            onDomReady();
        }

        winScope.once("popstate", () => {
            winScope.on("popstate", () => handler.handlePopState());
        });

        winScope.once("beforeunload", () => {
            winScope.on("beforeunload", () => handler.handleBeforeUnload());
        });

        winScope.once("pageshow", () => {
            winScope.on("pageshow", (event) => {
                if (event instanceof PageTransitionEvent) {
                    handler.handlePageShow(event);
                }
            });
        });

        winScope.once("pagehide", () => {
            winScope.on("pagehide", (event) => {
                if (event instanceof PageTransitionEvent) {
                    handler.handlePageHide(event);
                }
            });
        });

        docScope.once("visibilitychange", () => {
            docScope.on("visibilitychange", () => handler.handleVisibilityChange());
        });
    }
}

export { Spinnerlistener };

function createSpinnerHandlerSingletonSlot(): SpinnerHandler | null {
    return null;
}

let spinnerHandlerSingleton = createSpinnerHandlerSingletonSlot();

function initSpinnerSystem(): void {
    if (!spinnerHandlerSingleton) {
        spinnerHandlerSingleton = new SpinnerHandler();
    }

    Spinnerlistener.setup(spinnerHandlerSingleton);
}

export { initSpinnerSystem };
